import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import http from '../shared/http';
import endpoints from '../../config/endpoints';
import { createSelectOptionsFromSysEnums } from '../shared/form-elements/select';
import { actions as rootActions } from '../root';
// actions types
const TEST = 'showcase/test';

const FETCH_SUGGEST_SUCCESS = 'showcase/fetch-suggest-success';
const FETCH_SUGGEST_ERROR = 'showcase/fetch-suggest-error';

// initial state
const initialState = {
	data: null,
	error: false
};

// actions
export const actions = {
	test: ({
		type: TEST
	}),

	loadOptions: text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
			method: 'get',
			actions: [
				FETCH_SUGGEST_SUCCESS,
				FETCH_SUGGEST_ERROR
			]
		});

		return request(dispatch).then(action => {
			if (action.type === FETCH_SUGGEST_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnums(action.payload.data)
				};
			}
		});
	},

	spinnerToggle: () => (dispatch, getState) => dispatch(rootActions.spinnerToggle())
};

// reducers
export default handleActions({
	[TEST]: (state, action) => state
}, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.showcase.data,
	getFormInitial: state => ({
		asyncSelect: [
			{ value: 'one', label: 'One' },
			{ value: 'two', label: 'Two' },
			{ value: 'primary', label: 'Primary' }
		]
	}),
	getError: state => state.showcase.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/showcase/index.js